<template lang="pug">
  v-row
    v-col
      sdo-loader(v-if="loading")
      div(v-else)
        v-row(no-gutters).mb-5
          v-col.flex-grow-1
            .title {{ lesson.name }}
          v-col.flex-grow-0
            v-btn(
              bottom
              color="primary"
              dark
              rounded
              depressed
              text
              :to=`{ name: 'EducationLessonList',
                params: {
                  courseId: $route.params.courseId,
                  unitId: $route.params.unitId,
                }
              }`
            ).mb-2.ml-1 К урокам

        template
          v-tabs(
            v-model="tab"
            left hide-slider
            color="secondary"
          )
            v-tabs-slider
            v-tab.mr-2(
              active-class="active"
              v-for="(item, idx) in contentItems"
              :key="idx"
            ) {{ item.name }}
          v-tabs-items(v-model="tab")
            v-tab-item(
              v-for="(item, idx) in contentItems"
              :key="idx"
            )
              component(
                :is="item.component"
                :videos="lesson.content_links"
                :files="lesson.content_files"
                :lectures="lesson.content_lecture"
                :video-url="lesson.video_uri"
                :telegram="lesson.content_telegram"
              ).my-6
</template>
<script>
import ContentFiles from '@/modules/Education/Courses/components/LessonContent/ContentFiles.vue';
import ContentLectures from '@/modules/Education/Courses/components/LessonContent/ContentLectures.vue';
import ContentVideos from '@/modules/Education/Courses/components/LessonContent/ContentVideos.vue';
import ContentLinks from '@/modules/Education/Courses/components/LessonContent/ContentLinks.vue';
import ContentVideoLesson from '@/modules/Education/Courses/components/LessonContent/ContentVideoLesson.vue';
import {
  TASK_STATUSES,
} from '@/utils/constants';

// const VIDEO_LESSON_CONTENT = { name: 'Видео Урок', component: 'content-video-lesson' };

export default {
  components: {
    ContentFiles,
    ContentLectures,
    ContentVideos,
    ContentVideoLesson,
    ContentLinks,
  },
  props: {
    value: {
      type: Boolean,
      default: true,
    },

  },
  data() {
    return {
      openApproveDialog: false,
      loading: false,
      lesson: {},
      tab: null,
      dialog: false,
    };
  },
  computed: {
    lessonPassedText() {
      return this.lesson.user_passed ? 'Урок завершен' : 'Завершить можно только после выполнения задания';
    },
    isLessonPassed() {
      return this.lesson.tasks.every(
        (item) => item.status !== TASK_STATUSES.retake && item.status !== TASK_STATUSES.notPassed,
      );
    },
    contentItems() {
      return [
        ...this.lesson.content_links.length ? [{
          name: 'Что посмотреть?',
          component: 'content-videos',
          attrs: {
            videos: this.lesson.content_links,
          },
        }] : [],
        ...this.lesson.content_files.length ? [{
          name: 'Что почитать?',
          component: 'content-files',
          attrs: {
            files: this.lesson.content_files,
          },
        }] : [],
        ...this.lesson.content_lecture.length ? [{
          name: 'Конспекты',
          component: 'content-lectures',
          attrs: {
            lectures: this.lesson.content_lecture,
          },
        }] : [],
        ...this.lesson.content_telegram.length ? [{
          name: 'Telegram',
          component: 'content-links',
          attrs: {
            telegram: this.lesson.content_telegram,
          },
        }] : [],
      ];
    },
  },
  created() {
    this.loading = true;
    this.getMaterials();
  },
  methods: {
    getMaterials() {
      const id = this.$route.params.lessonId;
      const params = {
        expand: 'content_links,content_files,content_lecture,content_stream,tasks,content_telegram',
      };
      this.$rHandler(
        this.$api.lessons.getLesson(id, params),
        ({ data }) => {
          this.lesson = data.data;
          this.loading = false;
        },
      );
    },
  },
};
</script>
<style lang="scss" scoped>
.active {
  background: rgba(98, 117, 171, 0.2);;
  border-radius: 15px;
}
</style>
